// extracted by mini-css-extract-plugin
export default {"contentIconContainer":"p1FlwM","content":"b8vbpG","contentTitle":"bt7KjQ","contentInfo":"XQKEry","contentArrowIcon":"C2TaGT","contentIcon":"ZJ7n6I","contentContainer":"Cm_IsP"};